import { render } from "./ReadingQuestion.vue?vue&type=template&id=6891987b&scoped=true&ts=true"
import script from "./ReadingQuestion.vue?vue&type=script&lang=ts"
export * from "./ReadingQuestion.vue?vue&type=script&lang=ts"

import "./ReadingQuestion.vue?vue&type=style&index=0&id=6891987b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6891987b"]])

export default __exports__